<div class="bg" [style.background-image]="image">
  <div class="topleft logo-header">
    <img src="../../../assets/logo.webp" class="m-auto logo-cls" alt="BYF" />
  </div>

  <div class="myForm">
    <div class="card">
      <h4 class="card-header">BYF Labs</h4>
      <div class="card-body">
        <form *ngIf="!ssoLogin" #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>User ID</mat-label>
              <input matInput [(ngModel)]="login.userID" minlength="4" type="text" name="userID" #userID=ngModel
                required />
              <mat-icon matSuffix [ngStyle]="{'color':'#3db9b0'}">person</mat-icon>
              <mat-error *ngIf="userID.touched && userID.errors?.required">
                *User ID is required
              </mat-error>
              <mat-error *ngIf="userID.errors?.minlength">
                *User ID must be at least 4 characters long
              </mat-error>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Password</mat-label>
              <input matInput [(ngModel)]="login.pwd" minlength="8" type="{{ showPassword ? 'text' : 'password' }}"
                name="pwd" #pwd=ngModel required />
              <mat-icon matSuffix (click)="showPassword = !showPassword"
                [ngStyle]="{'color':'#3db9b0', 'cursor': 'pointer'}">{{ showPassword ? 'visibility' : 'visibility_off'
                }}</mat-icon>
              <mat-error *ngIf="pwd.touched && pwd.errors?.required">
                *Password is required
              </mat-error>
              <mat-error *ngIf="pwd.errors?.minlength">
                *Password must be at least 8 characters long
              </mat-error>
            </mat-form-field>
          </p>
          <button color="primary" class="login" mat-raised-button type="submit" [disabled]='!loginForm.valid || buttonClicked'>
            {{ buttonClicked ? "Signing In" : "Sign In" }}
            <span>
              <mat-icon *ngIf="buttonClicked">
                <mat-spinner diameter="25"></mat-spinner>
              </mat-icon>
            </span>
          </button>
          <p class="sso">
            <a routerLink="[]" (click)="ssoLogin = !ssoLogin">Sign in with SSO</a>
          </p>
        </form>
        <form *ngIf="ssoLogin" #ssoForm="ngForm" (ngSubmit)="onSSO(ssoForm)">
          <p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label>Email Address</mat-label>
              <input matInput [(ngModel)]="sso.email" (ngModelChange)="validateEmailList( email )" type="email" name="email" #email=ngModel required />
              <mat-icon matSuffix [ngStyle]="{'color':'#3db9b0'}">email</mat-icon>
              <mat-error *ngIf="email.touched && (email.errors ? email.errors['required'] : false)">
                *Email is required
              </mat-error>
              <mat-hint class="error" *ngIf="!emailerror">*Invalid Email Address</mat-hint>
            </mat-form-field>
          </p>
          <!-- <p>
            <button color="primary" class="login" mat-raised-button type="submit" [disabled]='!ssoForm.valid || !emailerror'>
              Submit
            </button>
          </p> -->
          <button color="primary" class="login" mat-raised-button type="button" (click)="onSSOdemo(ssoForm)" [disabled]='!ssoForm.valid || !emailerror || buttonClicked'>
            Submit
            <span>
              <mat-icon *ngIf="buttonClicked">
                <mat-spinner diameter="25"></mat-spinner>
              </mat-icon>
            </span>
          </button>
          <p class="sso">
            <a routerLink="[]" (click)="ssoLogin = !ssoLogin; emailerror = true;">Sign in with userID and password</a>
          </p>
        </form>
      </div>
    </div>
  </div>
</div>
